export const INGRESO_ROUTE = '/';
export const CATALOGO_ROUTE = '/catalogo-digital'